import { WorkType } from "./setupPaths";

/** The films are on Cloudflare Stream, played and pictured from videodelivery.net: the host the dashboard's frame-src
 * and img-src allow (not cloudflarestream.com), as for Replays. */
const PLAYER = "https://iframe.videodelivery.net/";
const THUMBNAILS = "https://videodelivery.net/";

export type SetupFilm = {
    /** for analytics */
    id: string;
    uid: string;
    /** where the part about setting up starts, in seconds */
    start: number;
    /** the second the thumbnail is taken from */
    frame: number;
    length: string;
};

/** The setup video: from the sign-up to the team on the map, in today's dashboard and app (thumbnail: the first-phone card). */
export const SETUP_VIDEO: SetupFilm = {
    id: "setup",
    uid: "7923f31b4905d869c729bee9aea8036b",
    start: 0,
    frame: 10,
    length: "3 min",
};

/** The film for this kind of work: one for everyone, until there are setup films per industry. */
export function filmFor(work: WorkType | undefined): SetupFilm {
    return SETUP_VIDEO;
}

export function filmPlayer(film: SetupFilm) {
    return `${PLAYER}${film.uid}?autoplay=true&startTime=${film.start}s`;
}
